import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

// Antd Components
import { Button, message, Modal, Spin } from "antd";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import PinField, { usePinField } from "react-pin-field";
import SwitchUserPin from "./SwitchUserPin";
import { login, logout } from "@/store/actions/auth";
import { useIdle } from "@custom-react-hooks/use-idle";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const LockScreenModal = ({ t, screenIsLocked, setScreenIsLocked }) => {
  const dispatch = useDispatch();
  const [isSwitchingUser, setIsSwitchingUser] = useState(false);
  const [newUser, setNewUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const pinCode = useSelector(
    (state) => state.profile.profile?.pin_code || state.auth.pin_code
  );
  const settings = useSelector((state) => state.auth.settings);
  const isIdle = useIdle(settings.auto_lock_screen_after_minutes * 1000 * 60);
  const config = useSelector((state) => state.config);
  const handler = usePinField();
  const handleKeyPress = (key) => {
    if (key === "{bksp}") {
      handler.setValue(handler.value.slice(0, -1));
    } else if (key === "{clear}") {
      handler.setValue();
    } else {
      handler.setValue(handler.value + key);
    }
  };
  const switchUser = async (inputedPin) => {
    try {
      setIsLoading(true);
      let res = await dispatch(
        login({ new_user_id: newUser.id, pinCode: inputedPin }, true)
      );
      if (res === "error") {
        message.error("Wrong Pin");
        setIsLoading(false);
      }
    } catch (err) {}
  };
  const validatePin = (inputedPin) => {
    handler.setValue("");

    if (newUser) {
      switchUser(inputedPin);
    } else {
      if (inputedPin === pinCode) {
        setScreenIsLocked(false);
        localStorage.removeItem("lockScreen");
        setIsSwitchingUser(false);
        setNewUser(null);
      } else {
        message.error("Wrong Pin");
      }
    }
  };

  // useEffect(() => {
  //   const activeIndex = Math.max(handler.value.length + 1, 0);
  //   const inputRef = handler.refs?.current[activeIndex];
  //   if (inputRef && typeof inputRef.focus === "function") {
  //     inputRef.focus();
  //   }
  // }, [handler.value, handler.refs]);
  if (
    isIdle &&
    !screenIsLocked &&
    settings.auto_lock_screen_after_minutes > 0
  ) {
    setScreenIsLocked(true);
    localStorage.setItem("lockScreen", 1);
  }
  return (
    <>
      <Modal
        style={{ top: 20 }}
        title={
          <div className="d-flex align-items-center justify-content-between">
            <span
              className="ant-modal-title "
              style={{
                textAlign: config.direction == "rtl" ? "right" : "left",
              }}
            >
              {newUser ? t("Enter Pin to Switch") : t("Enter Pin to Unlock")}
            </span>

            {settings.enable_user_switching_using_pin && (
              <Button
                type="link"
                onClick={() => {
                  setIsSwitchingUser(!isSwitchingUser);
                  handler.setValue("");
                  setNewUser(null);
                }}
              >
                {isSwitchingUser || newUser ? t("Back") : t("Switch User")}
              </Button>
            )}
          </div>
        }
        // destroyOnClose={true}
        footer={
          <div
            className="text-center"
            style={{
              width: "100%",

              fontSize: 12,
            }}
          >
            {t("Facing problems? Click")}{" "}
            <span
              onClick={() => {
                dispatch(logout());
                window.location.reload();
              }}
              style={{ color: "#0099cc", cursor: "pointer" }}
            >
              {t("here")}
            </span>{" "}
            {t("to logout")}
          </div>
        }
        closable={false}
        maskClosable={false}
        maskStyle={{ backdropFilter: "blur(8px)" }}
        open={screenIsLocked}
        bodyStyle={{
          paddingTop: 0,
          marginTop: 20,
          width: "auto",
          padding: "10px 10px",
          textAlign: config.direction === "ltr" ? "left" : "right",
        }}
      >
        <div
          className="px-2 mb-3 d-flex flex-column align-items-center "
          style={{ gap: 20 }}
        >
          {isSwitchingUser ? (
            <SwitchUserPin
              setNewUser={(newUser) => {
                setNewUser(newUser);
                setIsSwitchingUser(false);
              }}
            />
          ) : (
            <>
              <span>
                <PinField
                  style={{ visibility: isLoading && "hidden" }}
                  readOnly={true}
                  handler={handler}
                  length={4}
                  onComplete={validatePin}
                  type="password"
                  name="pin-code-xyz" // make sure this isn't predictable like "pin""
                  autoComplete="new-password" // or try "off"
                  className="custom-pin-input"
                />
              </span>
              {isLoading ? (
                <Spin indicator={antIcon} />
              ) : (
                <Keyboard
                  disableButtonHold
                  onKeyPress={handleKeyPress}
                  layout={{
                    default: ["1 2 3", "4 5 6", "7 8 9", "{clear} 0 {bksp}"],
                  }}
                  mergeDisplay
                  display={{
                    "{clear}": "Clear",
                    "{bksp}": "←",
                  }}
                  theme="hg-theme-default hg-theme-numeric hg-layout-numeric numeric-theme"
                  maxLength={4}
                />
              )}
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

export default withNamespaces()(LockScreenModal);
